import { render, staticRenderFns } from "./Deletar.vue?vue&type=template&id=d872778e&"
import script from "./Deletar.vue?vue&type=script&lang=js&"
export * from "./Deletar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports